import { default as videojs } from 'video.js';
import { ComponentBaseOptions } from '../models';
import { ComponentBase } from './component-base';
import { OverlayButton } from './overlay-button';
import Component = videojs.Component;

export class Overlay extends ComponentBase {

    static readonly ComponentName: string = 'Overlay';

    private play: OverlayButton;
    private pause: OverlayButton;

    private back: OverlayButton;
    private forward: OverlayButton;

    private volumeUp: OverlayButton;
    private volumeDown: OverlayButton;

    private readonly isMobile: boolean;

    constructor(player: videojs.Player, options?: ComponentBaseOptions, readyCallback?: Component.ReadyCallback) {
        super(player, {...options, name: 'Overlay'}, readyCallback);

        this.isMobile = options.isMobile;

        this.play = <OverlayButton>this.addChild(OverlayButton.ComponentName, {
            classList: 'material-icons overlay-button ripple hide play-arrow',
            text: 'play_arrow',
        });
        this.pause = <OverlayButton>this.addChild(OverlayButton.ComponentName, {
            classList: 'material-icons overlay-button ripple hide pause-arrow',
            text: 'pause',
        });

        this.back = <OverlayButton>this.addChild(OverlayButton.ComponentName, {
            classList: 'material-icons overlay-button ripple hide arrow-back',
            text: 'fast_rewind',
        });
        this.forward = <OverlayButton>this.addChild(OverlayButton.ComponentName, {
            classList: 'material-icons overlay-button ripple hide arrow-forward',
            text: 'fast_forward',
        });

        this.volumeUp = <OverlayButton>this.addChild(OverlayButton.ComponentName, {
            classList: 'material-icons overlay-button ripple hide volume-up',
            text: 'volume_up',
        });

        this.volumeDown = <OverlayButton>this.addChild(OverlayButton.ComponentName, {
            classList: 'material-icons overlay-button ripple hide volume-down',
            text: 'volume_down',
        });
    }

    name(): string {
        return Overlay.ComponentName;
    }

    createEl(): Element {
        return super.createEl('div', {
            className: 'vjs-planet-overlay',
        });
    };

    togglePlayback(play?: boolean): void {
        if (play) {
            this.pause.show();
        } else {
            this.play.show();
        }
    }

    handleDoubleClick(event: MouseEvent): void {
        if (this.isMobile) {
            const playerWidth: number = this.player().contentEl().getBoundingClientRect().width;
            if (event.clientX > playerWidth / 2) {
                this.seekForward();
            } else {
                this.seekBackward();
            }
        }
    }

    seekForward(): void {
        if (!this.player().ended()) {
            let time: number = this.player().currentTime();
            time += 10;
            this.forward.show();
            this.player().currentTime(time);
        }
    }

    seekBackward(): void {
        if (this.player().currentTime() !== 0) {
            let time: number = this.player().currentTime();
            time -= 10;
            this.back.show();
            this.player().currentTime(time);
        }
    }

    turnVolumeUp(): void {
        const volume: number = this.player().volume();
        if (volume !== 1) {
            if (this.player().muted()) {
                this.player().muted(false);
            }
            this.player().volume(volume + 0.05);
            this.volumeUp.show();
        }
    }

    turnVolumeDown(): void {
        const volume: number = this.player().volume();
        if (volume !== 0) {
            this.player().volume(volume - 0.05);
            this.volumeDown.show();
        }
    }
}

videojs.registerComponent(Overlay.ComponentName, Overlay);
videojs.registerComponent(OverlayButton.ComponentName, OverlayButton);
